module.exports = __webpack_public_path__ + "img/logo3.ee693305.png";